// @ts-strict-ignore
import { enums } from "@optimizely/optimizely-sdk";
import { logger } from "observability";

function log(level, message) {
  const { LOG_LEVEL } = enums;
  const logMessage = `[OPTIMIZELY LOGGER]: ${message}`;
  switch (level) {
    case LOG_LEVEL.INFO:
    case LOG_LEVEL.DEBUG:
    case LOG_LEVEL.WARNING:
      break;
    case LOG_LEVEL.ERROR:
      logger.error(logMessage);
      break;
  }
}

export default { log };
